import { Box, Button, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { AppDialog } from "AttendanceForm/Components/Dialog/Dialog";
import { useTranslation } from "react-i18next";
import CancelIcon from "@mui/icons-material/Cancel";

interface SubmissionFailureModalProps {
  isOpen: boolean;
  onClose: () => void;
  eventName: string;
  eventDate: string;
  error?: string;
}

export const SubmissionFailureModal = ({
  isOpen,
  onClose,
  eventDate,
  eventName,
  error,
}: SubmissionFailureModalProps) => {
  const { t } = useTranslation("learnerDetailsForm");
  const { t: tcommon } = useTranslation("common");
  const styles = useStyles();

  return (
    <AppDialog
      id="submissionFailureModal"
      maxWidth="md"
      open={isOpen}
      title={t("failedSubmissionPopupTitle")}
      onCloseHandler={onClose}
      popupIcon={<CancelIcon className={styles.icon} />}
    >
      <Typography gutterBottom>{t("failedSubmissionSummaryTwo")}</Typography>
      <Box paddingTop={2} paddingBottom={2}>
        <Typography id="event-name-id" gutterBottom>
          <strong>
            {tcommon("eventName")} {"'" + eventName + "'"}
          </strong>
        </Typography>
        <Typography id="event-date-id" gutterBottom>
          <strong>
            {" "}
            {tcommon("eventDate")} {eventDate}{" "}
          </strong>
        </Typography>
      </Box>
      {error && (
        <Box paddingBottom={3}>
          <Typography gutterBottom color="error">
            <strong>
              {t("failureReason")}
              {error}
            </strong>
          </Typography>
        </Box>
      )}
      <Typography>{t("cancelPopupHelper")}</Typography>
      <Box display="flex" justifyContent="flex-end" paddingTop={2}>
        <Button variant="contained" color="primary" onClick={onClose}>
          {tcommon("close")}
        </Button>
      </Box>
    </AppDialog>
  );
};

const useStyles = makeStyles(() => ({
  icon: {
    color: "#F44336",
  },
}));
